import type { DeviceInfo } from "../model/types";

export const deviceInfo = (): DeviceInfo => {
    const nav = navigator as Navigator & {
        userAgentData?: { platform?: string };
        standalone?: boolean;
    };
    const ua = nav.userAgent || "";
    const touch = (nav.maxTouchPoints || 0) > 0;
    const sw = window.screen?.width || 0;
    const sh = window.screen?.height || 0;
    // iPadOS представляется Macintosh'ем, планшеты на Android — без «Mobile»;
    // сенсорный ноутбук на Windows при этом остаётся компьютером.
    const tablet =
        /iPad|Tablet/i.test(ua) ||
        (touch && Math.min(sw, sh) >= 600 && /Android|Macintosh/i.test(ua));
    const mobile = /Mobi|Android|iPhone|iPad/i.test(ua);
    let standalone = !!nav.standalone;
    try {
        standalone = standalone || window.matchMedia("(display-mode: standalone)").matches;
    } catch {
        /* нет matchMedia */
    }
    return {
        class: tablet ? "tablet" : mobile ? "mobile" : "desktop",
        ua: ua.slice(0, 200),
        platform: String(nav.userAgentData?.platform || nav.platform || "").slice(0, 40),
        viewport: [window.innerWidth || 0, window.innerHeight || 0],
        screen: [sw, sh],
        dpr: Math.round((window.devicePixelRatio || 1) * 100) / 100,
        touch,
        browser_lang: String(nav.language || "").slice(0, 20),
        standalone,
    };
};

/** Хеш сборки: из переменной сборки, иначе из имени main.<hash>.js. */
export const appCommit = (): string | null => {
    const fromEnv = process.env.REACT_APP_COMMIT;
    if (fromEnv) return fromEnv.slice(0, 40);
    try {
        const s = document.querySelector<HTMLScriptElement>('script[src*="/static/js/main."]');
        const m = s?.src.match(/main\.([0-9a-f]{7,40})\./);
        return m ? m[1] : null;
    } catch {
        return null;
    }
};
